import Collaborators from '../collaborators'
import Form from './form'

export default function Settings() {
  return (
    <div className="py-4">
      <Form />
      <div className="mt-12">
        <Collaborators />
      </div>
    </div>
  )
}
